import React from 'react';
import { motion } from 'framer-motion';
import { Mail, Phone, MapPin } from 'lucide-react';
// import insta from '../style/images/catapult_insta.jpeg';
import logo from '../style/thermal_img/logo.PNG';

const Footer = () => {
  return (
    <footer className="footer-section">
      <motion.div
        className="footer-container"
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        viewport={{ once: true }}
      >
        <div className="footer-grid">
          {/* Company Info */}
          <div className="footer-brand">
            <h3>Amrita Thermal Engineering (ATE)</h3>
            <p>Transforming visions into unforgettable experiences.</p>
            <img src={logo} alt="Insta" className="footer-logo" width={150} height={80}/>
          </div>

          {/* Contact Info */}
          <div className="footer-contact">
            <h4>Contact</h4>
            <p><Phone className='icon' size={18} /> +91 7397439282</p>
            <p><Mail className='icon' size={18} /> amritathermaladmin@gmail.com</p>
            <p><MapPin className='icon' size={18} /> 124 & 123 Dairy Road SIDCO Industrial Estate Ambattur Chennai-600 098 </p>
          </div>

          {/* Quick Links */}
          <div className="footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About Us</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#products">Products</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <p>© {new Date().getFullYear()} Amrita Thermal Engineering (ATE). All rights reserved.</p>
        </div>
      </motion.div>
    </footer>
  )
}

export default Footer